import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  &.left_panel_app {
    display: flex;
    flex-direction: column;
  }
  .left_header_space {
    width: 350px;
    height: 70px;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    z-index: 3;
  }
  .games_panel {
    position: relative;
    border-radius: 0 10px 0 0;
    top: 70px;
    overflow: auto;
    height: calc(100% - 70px);
  }
  .togCheck {
    display: none;
  }
  .togContent {
    max-width: 90px;
    width: 350px;
    overflow: hidden;
    font-size: 0.8rem;
    transition: all 0.5s;
    margin: 10px 0 0 0;
  }
  .games_panel .togCheck:checked + .togContent {
    max-width: 350px;
  }
  .games_panel .togButton {
    display: flex;
    width: 17px;
    height: 17px;
    padding: 20px 40px 20px 10px;
    cursor: pointer;
    mask: url(${icons.panel_collapse_icon}) center center / 17px 15px no-repeat;
    background: rgb(99, 104, 109);
    background: #fff;
    position: sticky;
    left: 350px;
    top: 5px;
    z-index: 3;
  }

  .games_panel input.togCheck:checked ~ .togButtom {
    left: 45px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  @media (max-width: 1600px) {
    .games_panel .togCheck:checked + .togContent {
      width: 250px;
      max-width: 250px;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (min-width: 1601px) {
    .games_panel {
      background: hsla(0, 0%, 100%, 0.07);
    }
  }
  @media (max-width: 1600px) {
    .games_panel {
      position: relative;
      background: hsla(0, 0%, 100%, 0.1);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      top: 70px;
      left: 0;
      z-index: 3;
    }
    .left_header_space {
      width: 180px;
    }
    .games_panel .togButton {
      z-index: 3;
    }
  }
  @media (max-width: 1250px) {
    .games_panel {
      position: relative;
      background: hsla(214, 18%, 25%, 0.5);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      top: 70px;
      left: 0;
      z-index: 3;
    }
  }
  @media (max-width: 800px) {
    .games_panel .togButton {
      z-index: 3;
      width: 30px;
      padding: 20px 0;
    }
    .left_header_space {
      width: 140px;
    }
    .togContent {
      max-width: 30px;
    }
  }
  @media (max-width: 430px) {
    .left_header_space {
      height: 50px;
    }
    .games_panel {
      top: 50px;
    }
    .games_panel {
      height: calc(100% - 50px);
    }
  }
`

const makePanelFloatCSS = css`
  @media (max-width: 1600px) {
    .games_panel {
      position: fixed;
      top: 70px;
      left: 0;
    }
    .games_panel .togCheck:checked + .togContent {
      width: 350px;
      max-width: 350px;
    }
  }
`

const developerCSS = css``

export const LeftPanelAppCSS = styled.div`
  ${designerCSS}
  ${makePanelFloatCSS}
  ${developerCSS}
`
